import React, { useState } from 'react';
import { connect } from 'react-redux';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import { closeModal, setCurrentStep, stepEnum } from '../IMEIDeviceRepairSlice';
import Title from '../Shared/Title';
import ReactSelect from 'app/Components/Shared/ReactSelect/ReactSelect';

const MultipleIMEI = (props) => {
  const [selectedIMEI, setSelectedIMEI] = useState(null);

  const handleIMEISelection = (imei) => {
    setSelectedIMEI(imei);
  };

  const continueWithSelectedIMEI = () => {

    props.setCurrentStep(stepEnum.CAUSE_SELECTION);
    props.closeModal();
  };

  const close = () => {
    props.closeModal();
  };

  return (
    <div className='multiple-imei-popup'>
      <Title text={`Multiple IMEIs found`} subtext={`Please select one to continue`} />
      <div className='imei-selection-area'>
        <div>
          <p className='text-right M_Sub_Title'>עבור איזה IMEI ברצונך לבקש שירות?</p>
          <ReactSelect
            getOptionLabel={(option) => option.value}
            getOptionValue={(option) => option.key}
            placeholder='בחירת ח.פ.'
            value={selectBoxObj.filter((option) => option.key == props.portalsBlock.selectedHetPay)}
            name='selected'
            options={props.deviceRepairData.IMEIList}
            onChange={(e) => validateSelectedOrg(e.key)}
          />
        </div>
      </div>
      <div className='buttons-area'>
        <BtnSubmit text={'Continue with selected IMEI'} onclick={continueWithSelectedIMEI} />
        <BtnSubmit text={'Close'} onclick={close} />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {deviceRepairData: state.iMEIDeviceRepair};
};

const mapDispatchToProps = {closeModal, setCurrentStep};

export default connect(mapStateToProps, mapDispatchToProps)(MultipleIMEI);
